/*
 * Copyright (c) 2020.  Sanish Manandhar
 * All Rights Reserved
 */
import {
  SEND_CHAT_NOTIFICATION_REQUEST,
  SEND_CHAT_NOTIFICATION_REQUEST_SUCCESS,
  SEND_CHAT_NOTIFICATION_REQUEST_FAILURE,
  SEND_AUTOMATIC_MESSAGE_REQUEST,
  SEND_AUTOMATIC_MESSAGE_REQUEST_SUCCESS,
  SEND_AUTOMATIC_MESSAGE_REQUEST_FAILURE,
} from './type';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  error: {},
  automaticMessage: [],
  automaticMessageLoading: false,
  automaticMessageError: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const chatReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case SEND_CHAT_NOTIFICATION_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SEND_CHAT_NOTIFICATION_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        error: {},
      });

    case SEND_CHAT_NOTIFICATION_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        error: action.error,
      });

    case SEND_AUTOMATIC_MESSAGE_REQUEST:
      return Object.assign({}, state, {
        automaticMessageLoading: true,
      });

    case SEND_AUTOMATIC_MESSAGE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        automaticMessage: action.data,
        automaticMessageLoading: false,
        automaticMessageErrort: {},
      });

    case SEND_AUTOMATIC_MESSAGE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        automaticMessageLoading: false,
        automaticMessageErrort: action.error,
      });

    default:
      return state;
  }
};

export default chatReducer;
